module.exports = __webpack_public_path__ + "img/logo.91a75c7d.png";